// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d35530d0","455":"f15c4e62","977":"d18a8296"}[chunkId] + ".chunk.js";
};